import { Chip, Tooltip } from "@mui/joy";

const MAP = {
  green:  { color: "success", label: "Допуск" },
  yellow: { color: "warning", label: "Под вопросом" },
  red:    { color: "danger",  label: "Не доверяем" },
};

/** Бейдж вердикта ИИ. props: status ('none'|'green'|'yellow'|'red'), reason (string), confidence (0..1) */
export default function AiStatusBadge({ status, reason, confidence }) {
  if (!status || status === "none") {
    return <Chip size="sm" variant="soft" color="neutral">ИИ: не проверено</Chip>;
  }
  const m = MAP[status] || MAP.yellow;
  const pct = confidence != null ? ` · ${Math.round(confidence * 100)}%` : "";
  const chip = (
    <Chip size="sm" variant="soft" color={m.color}>
      ИИ: {m.label}{pct}
    </Chip>
  );
  return reason ? <Tooltip title={reason} variant="soft" arrow>{chip}</Tooltip> : chip;
}